import Link from 'next/link'
import { Typography } from 'common/typography'
import { NeutralButtonOutline } from 'common/button'
import { useLessons } from 'querys/lesson'
import { useCourse } from 'querys/course'
import { Play } from 'components/icons'
import Divider from 'common/divider'
import FreeCourseCard from './video-card/free-course-card'
import PricingVariants from './video-card/pricing-variants'


function PaymentStatus() {
  // const { data: { is_active } } = useSubscriptionStatus({ product: 'ALL' })
  const {
    data: { has_access: hasCourseAccess, last_viewed_lesson, slug, is_free },
  } = useCourse()
  const { data: chapters } = useLessons()
  const lastLessonSlug = last_viewed_lesson?.slug || (chapters && chapters[0]?.lessons[0]?.slug)
  const lastLesson = last_viewed_lesson?.title || (chapters && chapters[0]?.lessons[0]?.title)
  const lessonUrl = `/aprender/${slug}/${lastLessonSlug}`
  return (
    <>
      {is_free && <FreeCourseCard slug={slug} hasCourseAccess={hasCourseAccess} />}
      {!is_free && !hasCourseAccess && (
        <PricingVariants />
      )}
      {hasCourseAccess && (
          <>
            <Typography as="h3" font="headline5" color="var(--baseNeutral)">
              {lastLesson}
            </Typography>
            <Divider marginBottom={16} marginVertical={0} marginHorizontal={0} color="transparent" />
            <Link href={lessonUrl} prefetch={false} passHref>
              <NeutralButtonOutline
                padding={16}
                fullWidth
                fontWeight="500"
                responsive
              >
                <Play margin="0 8px" width="19px" height="19px" color="var(--baseFullContrast)" />
                Continuar con el curso
              </NeutralButtonOutline>
            </Link>
          </>
      )}
    </>
  )
}

export default PaymentStatus
